module.exports = __webpack_public_path__ + "static/media/H.b793c9f1.png";